import React, { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import $, { unique } from "jquery";
import CallAPI from "../../../services/apiCalls";
import useUserStore from "../../../utils/storeApp";
import { useNavigate } from "react-router-dom";

const SearchMessageStatus = () => {
  //listcustomer.js
  const {
    userRole,
    userToken,
    setCustomerObj,
    userSession,
    setCustomerFlag,
    SetSharedObject,
    sharedObject,
  } = useUserStore((state) => ({
    setCustomerObj: state.setCustomerObj,
    userRole: state.userRole,
    userToken: state.userToken,
    setCustomerFlag: state.setCustomerFlag,
    SetSharedObject: state.SetSharedObject,
    sharedObject: state.sharedObject,
    userSession: state.userSession,
  }));

  const [fromAddress, setFromAddress] = useState("");
  const [processing, SetProcessing] = useState(false);
  const [submFlag, setSubmFlag] = useState(false);
  const [sendStatus, setSendStatus] = useState("All");
  const [isMDN, setIsMDN] = useState(null);
  const [date, setDate] = useState(null);
  const [startdate, setStartDate] = useState(null);
  const [enddate, setEndDate] = useState(null);
  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());

  useEffect(() => {
    setSubmFlag(false);
    $("#startDate")
      .datepicker()
      .on("changeDate", function (e) {
        setNewDate(e.date);
        setStartDate(new Date(e.date));
        $("#startDate").datepicker("hide");
        let dt = e.date;
        let max = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + 30);
        $("#endDate").datepicker("setDate", max);
        $("#endDate").datepicker("show");
      });
    $("#endDate")
      .datepicker()
      .on("changeDate", function (e) {
        setDate(new Date(e.date));
        setEndDate(new Date(e.date));
        $("#endDate").datepicker("hide");
      });
    $("#startDate").datepicker("setDate", getLastWeek());
    $("#endDate").datepicker("setDate", new Date());
    setEndDate(new Date(getLastWeek()));
    setStartDate(new Date());
  }, []);

  const getLastWeek = () => {
    let today = new Date();
    let lastWeek = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 7
    );
    return lastWeek;
  };
  const setNewDate = (selected) => {
    let dt = new Date(selected);
    let today = new Date();
    setMinDate(dt);
    let max = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + 30);
    setMaxDate(max);
    if (max > today) {
      setMaxDate(today);
    }
    $("#endDate").datepicker("setStartDate", dt);
    $("#endDate").datepicker("setEndDate", max);
    $("#endDate").datepicker("setDate", null);
    setEndDate(null);
  };

  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }
  async function getMessages() {
    setSubmFlag(true);
    let StartDate = $("#startDate").datepicker("getFormattedDate");
    let EndDate = $("#endDate").datepicker("getFormattedDate");
    if (isEmpty(StartDate)) {
      document.getElementById("startDateId").scrollIntoView();
      document.getElementById("startDateId").focus();
      setStartDate(null);
      return;
    } else if (isEmpty(EndDate)) {
      document.getElementById("endDateId").scrollIntoView();
      document.getElementById("endDateId").focus();
      setEndDate(null);
      return;
    }
    SetProcessing(true);
    let call = "/users/GetMessageStatus";
    let search = {};

    if (isMDN === null) {
      search = {
        ToAddress: fromAddress,
        StartDate: new Date(StartDate),
        EndDate: new Date(EndDate),
        OrganizationId: userSession.org_id,
        MessageSource: "Sent",
        sortBy: "SentDate",

        sortDir: "SentDate",
      };
    } else {
      search = {
        ToAddress: fromAddress,
        StartDate: new Date(StartDate),
        EndDate: new Date(EndDate),
        Mdn: isMDN,
        OrganizationId: userSession.org_id,
        MessageSource: "Sent",
        sortBy: "SentDate",
        sortDir: "SentDate",
      };
    }

    let finalSearch = search;
    if (sendStatus !== "All") {
      finalSearch = { ...search, SendStatus: sendStatus };
    }
    console.log(finalSearch);
    const res = await CallAPI(call, finalSearch, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetSharedObject("previousSearch", finalSearch);
      //SetSharedObject("messageStatusResults", res.data.data.pageItems);
      SetSharedObject("recievedMessageStatusResults", res.data.data.pageItems);
      SetSharedObject("messageStatusResultsFlag", true);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    SetProcessing(false);
  }

  const changeMDN = (e) => {
    let mdnString = e.target.value;
    let isMDN = null;
    if (mdnString === "All") {
      isMDN = null;
    } else if (mdnString === "Yes") {
      isMDN = true;
    } else if (mdnString === "No") {
      isMDN = false;
    }
    setIsMDN(isMDN);
  };

  const changeAddress = (e) => {
    setFromAddress(e.target.value);
  };

  return (
    <div className="SearchMessageStatus">
      <div
        className="modal fade"
        id="MsgStatusSearchModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="MessageStatusSearch"
        aria-hidden="false"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <div
                className="modal-title spacer-inline text-size3"
                id="myModalLabel"
              >
                Search
              </div>
              <button
                type="button"
                className="close"
                aria-label="Close"
                data-dismiss="modal"
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="modal-content-body container">
                  {/* Sent To*/}
                  <div className="field-wrapper">
                    <label for="SentTo">Sent To</label>
                    <input
                      className="form-control"
                      name="SentTo"
                      id="SentTo"
                      placeholder="Enter Direct Email"
                      onChange={changeAddress}
                    />
                  </div>
                  <div className="field-wrapper">
                    {/*Start Date*/}
                    {/*onChange={(date) => { console.log("hello"); setNewDate(date.target.value) }}*/}
                    {/*data-date-start-date="-1M"*/}
                    <div className="spacer-margin5 spacer-inline w-md2 v-top">
                      <label for="StartDate">Start Date</label>{" "}
                      <i className="bi bi-asterisk rd-clr"></i>
                      <div
                        className="input-group date"
                        data-provide="datepicker"
                        id="startDate"
                        data-date-end-date="1d"
                      >
                        <input
                          type="text"
                          className="form-control"
                          name="StartDate"
                          id="startDateId"
                        />
                        <div className="input-group-append">
                          <span className="input-group-text" id="">
                            <i className="fas fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                      {submFlag && isEmpty(startdate) ? (
                        <div className="alert alert-danger">Required!</div>
                      ) : null}
                    </div>

                    {/*End Date*/}
                    <div className="spacer-inline w-md2 v-top">
                      <label for="EndDate">End Date</label>{" "}
                      <i className="bi bi-asterisk rd-clr"></i>
                      <div
                        className="input-group date end-date"
                        data-provide="datepicker"
                        id="endDate"
                        data-date-start-date={minDate}
                        data-date-end-date={maxDate}
                      >
                        <input
                          type="text"
                          className="form-control"
                          name="EndDate"
                          id="endDateId"
                        />
                        <div className="input-group-append">
                          <span className="input-group-text" id="">
                            <i className="fas fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                      {submFlag && isEmpty(enddate) ? (
                        <div className="alert alert-danger">Required!</div>
                      ) : null}
                    </div>
                    <div className="sp-margin13">
                      Set a date range to specify results within 30 days.{" "}
                    </div>
                  </div>

                  <div className="field-wrapper">
                    {/*MDN*/}
                    <div className="spacer-margin5 spacer-inline w-md2">
                      <label for="mdn">Message Type</label>
                      <select
                        className="form-control"
                        name="mdn"
                        onChange={changeMDN}
                      >
                        <option value="All">All</option>
                        <option value="Yes">MDN</option>
                        <option value="No">Not MDN</option>
                      </select>
                    </div>
                    {/*Status*/}
                    <div className="spacer-inline w-md2">
                      <label for="status">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        onChange={(e) => setSendStatus(e.target.value)}
                      >
                        <option value="All">All</option>
                        <option value="Confirmed">Confirmed</option>
                        <option value="Failed">Failed</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={getMessages}
                >
                  Search
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                {/*Processing Spinner*/}
                {processing ? <div className="loading"></div> : null}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchMessageStatus;
